import { Badge } from '@/shared/components/ui/badge';
import TagSelector from '@/shared/components/ui/TagSelector';
import { Filter } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';
import { useTagStore } from '@/features/tags/store/useTagStore';
import { useTagActions } from '@/features/tags/hooks/useTagActions';
import { useTagsQuery } from '@/features/tags/hooks/useTagsQuery';

const FilterConfig = ({ showCount = true }: { showCount?: boolean }) => {
  const { data: tags = [] } = useTagsQuery();
  const activeFilters = useTagStore(state => state.activeFilters);
  const { deleteTag, updateTag, toggleFilter, clearFilters } = useTagActions();

  const trigger = (
    <div className="h-8 w-8 px-2 flex justify-center items-center hover:bg-accent hover:text-accent-foreground rounded group relative cursor-pointer">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Filter className="h-4 w-4" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Filter List</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      {showCount && activeFilters.length > 0 && (
        <Badge
          className="absolute -top-2 -right-2 h-5 w-5 p-0 flex items-center justify-center bg-transparent text-primary-foreground"
          variant="default"
        >
          {activeFilters.length}
        </Badge>
      )}
    </div>
  );

  return (
    <TagSelector
      trigger={trigger}
      tags={tags}
      selectedTags={activeFilters}
      onSelect={toggleFilter}
      onDelete={deleteTag}
      onEdit={updateTag}
      reset={clearFilters}
      emptyMessage="No filters available"
    />
  );
};

export default FilterConfig;
